const Terms = () => (
  <div className="max-w-3xl mx-auto px-6 py-12 text-gray-700">
    <h1 className="text-3xl font-bold mb-2 text-purple-700">Terms of Use</h1>
    <p className="text-sm text-gray-400 mb-8">Last updated: May 2026</p>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">1. Acceptance</h2>
      <p className="leading-relaxed">
        By accessing stray-apps.com you agree to these Terms. If you do not agree, please do not use the site.
      </p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">2. Use of the service</h2>
      <ul className="list-disc pl-5 space-y-2 leading-relaxed">
        <li>You must be at least 13 years old to create an account.</li>
        <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
        <li>You agree not to use the service for any unlawful purpose or to violate any applicable laws.</li>
      </ul>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">3. Intellectual property</h2>
      <p className="leading-relaxed">
        All content, trademarks, and intellectual property on this site are owned by Stray AppTech Pte. Ltd.
        unless otherwise stated. You may not reproduce or redistribute content without written permission.
      </p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">4. Disclaimer</h2>
      <p className="leading-relaxed">
        The service is provided "as is" without warranties of any kind. Stray AppTech Pte. Ltd. is not
        liable for any damages arising from your use of the site.
      </p>
    </section>

    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-3 text-gray-800">5. Changes</h2>
      <p className="leading-relaxed">
        We may update these Terms at any time. Continued use of the site after changes constitutes acceptance.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3 text-gray-800">6. Contact</h2>
      <p className="leading-relaxed">
        Stray AppTech Pte. Ltd. · Singapore ·{' '}
        <a href="mailto:contact@stray-apps.com" className="text-purple-600 hover:underline">contact@stray-apps.com</a>
      </p>
    </section>
  </div>
);

export default Terms;
